import { OrganizationStage } from 'typings/enums';

export const WELCOME_STORAGE_KEY = 'already-welcomed';

export const OrganizationStagesApiMap = {
  [OrganizationStage.qualification]: 'qualification',
  [OrganizationStage.ongoing]: 'ongoing',
};
